import { Ability } from "@casl/ability";
import { initialAbility } from "./config";

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
let existingAbility = null;
try {
  const item = localStorage.getItem("userAbility");
  const parsed = item ? JSON.parse(item) : null;
  existingAbility = Array.isArray(parsed) ? parsed : null;
} catch (e) {
  console.warn("Failed to parse userAbility from localStorage:", e);
  localStorage.removeItem("userAbility");
}

export default new Ability(existingAbility || initialAbility);
// export default new Ability(initialAbility);
